import React from 'react'

const index = (data) => {
  return (
    <div className='w-[270px]  rounded-md mx-auto bg-[#1D1332] blur-[3px] my-8 lg:my-12'>
    </div> 
  )
}

export default index
